function fn_layout_header() {
    // CORE
    var $main_header = $("#main_header");
    var $header = $main_header.find(".header");
    var $header_bar = $main_header.find(".header_bar");
    var $header_nav = $header.find("nav");

    $main_header.after('<div id="main_nav"><div class="top_nav"></div></nav>');

    var $main_nav = $(document).find("#main_nav");
    var $top_nav = $main_nav.find(".top_nav");
    var $logo = $header.find(".icon-logo").clone();
    var $nav = $header.find("nav").clone();
    var $info = $header_bar.find(".info").clone();
    var $login = $header_bar.find(".login").clone();
    var $social = $header_bar.find(".social").clone();
    var $langs = $header_bar.find(".langs").clone();

    $top_nav.append($logo);
    $top_nav.append($login);
    $main_nav.append($nav);
    $main_nav.append($info);
    $main_nav.append($social);
    $main_nav.append($langs);

    nl_fn_responsive_menu();

    $header.find("[data-header-search]").on("click",function(e){
        e.preventDefault();
        $(this).closest(".actions").toggleClass("toggle");
       $(this).toggleClass("icon-close").parents(".search").toggleClass("active").find("input").fadeToggle(500).focus();
    });
    $header_bar.find("[data-header-langs]").on("click",function(e){
        e.preventDefault();
        $(this).parent(".active").toggleClass("toggle").parents(".langs").find(".list").toggleClass("active").slideToggle(500);
    });
    $(window).scroll(function(){
        if($("[data-header-langs]").parent(".active").hasClass("toggle")) {
            $("[data-header-langs]").trigger("click");
        }
    });
}